export default __webpack_public_path__ + "static/media/goodAtt.f2cb419a.svg";